import React from 'react'
import { SectionElement, SectionElementProps } from '../components/SectionElement/SectionElement'
import { data } from '../data'
import { FooterElement } from '../components/Footer/Footer'
import { HeaderElement } from '../components/Header/Header'
import '../main.css'

const Main = () => (
    <>
        <HeaderElement />
        <div className="cover">
            <img src={"/images/games/lupusmaster_cover.png"} width="100%" alt="cover"/>
            <div className="cover_cta"><h1>Available now!</h1></div>
        </div>
        <div className="container">
            <div className="section_title section_title_games">
                OUR GAMES
            </div>
            <div className="element_section">
                {
                    data[0].map((game: SectionElementProps) => <SectionElement {...game}/>)
                }
            </div>
        </div>
        <div className="container">
            <div className="section_title section_title_aboutus">
                ABOUT US
            </div>
            <div className="element_section">
                {
                    data[1].map((developer: SectionElementProps) => <SectionElement {...developer}/>)
                }
            </div>
        </div>
        <div className="container">
            <div className="section_title">
                CONTACT US
            </div>
            <div className="contactus_text">
                You can contact us to <a href="mailto:info@matterflies.com">info@matterflies.com</a>
            </div>
        </div>
        <FooterElement />
    </>
)

export { Main }
